import React from 'react';
import Container from '../components/Container';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useBasicSurveyMeta } from '../hooks';
import assets from '../assets';
import SomethingWentWrong from '../../../../../components/SomethingWentWrong';
import PageLoading from '../../../../../components/PageLoading';
import FormattedSurvey from '../components/FormattedSurvey';
import Title from '../components/Title';

export default function StakeholderSurveyEnd() {
  const { t } = useTranslation();
  const { token } = useParams();
  const { data: meta, isError } = useBasicSurveyMeta(token);

  if (isError) return <SomethingWentWrong />;
  if (!meta) return <PageLoading />;

  return (
    <Container header={<img src={assets.outro.image} />}>
      <div>
        <Title
          title={t('esg:stakeholderSurvey.title')}
          period={meta.report_period}
        />
        <FormattedSurvey
          text={meta.outro_text || t('esg:stakeholderSurvey.outro.message')}
        />
      </div>
    </Container>
  );
}
